import piniaPluginPersistedstate from 'pinia-plugin-persistedstate';
import { createPinia } from 'pinia';

export * from './auth';
export * from './ui';

/**
 * Create and configure Pinia store.
 *
 * Uses persisted state plugin to save selected state to localStorage.
 */
export function createPiniaStore() {
    const pinia = createPinia();

    // Add persisted state plugin
    pinia.use(piniaPluginPersistedstate);

    return pinia;
}
